import 'url-search-params-polyfill';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Success from '../../components/Success/Success';

import {
  successServiceNumberSelector,
  successActionSelector
} from '../../store/requestDataSuccess/selectors';
import { goToHomePage, goToFirstStep } from '../../store/step/actions';

class SuccessPage extends PureComponent {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { serviceNumber, action } = this.props;

    if (!serviceNumber) {
      this.props.goToHomePage();
    }

    return (
      <div className="SuccessPage">
        <Success
          action={action}
          serviceNumber={serviceNumber}
          goToFirstStep={this.props.goToFirstStep}
        />
      </div>
    );
  }
}

SuccessPage.defaultProps = {
  action: 'submit',
  serviceNumber: null
};

SuccessPage.propTypes = {
  goToFirstStep: PropTypes.func.isRequired,
  goToHomePage: PropTypes.func.isRequired,
  serviceNumber: PropTypes.string,
  action: PropTypes.string
};

const mapStateToProps = state => ({
  action: successActionSelector(state),
  serviceNumber: successServiceNumberSelector(state)
});

export default connect(mapStateToProps, dispatch =>
  bindActionCreators(
    {
      goToFirstStep,
      goToHomePage
    },
    dispatch
  )
)(SuccessPage);
